import React from 'react'

import { applyStyle, getSmartSize } from '../helpers/styles'
import { useBorderStyle } from './border'
import { useColor } from '../../components/theme/_hooks/colors'
import { usePaddingStyle } from './padding'

const SIZES = {
  xsmall: { height: 1.4, paddingV: 0.3 },
  small: { height: 1.8, paddingV: 0.4 },
  normal: { height: 2.4, paddingV: 0.6, paddingH: 0.9 },
  large: { height: 3, paddingV: 1 }
}

export const useInputStyle = props => {
  const { size, borderColor, bgColor, align, disabled } = props

  const sizeValue = getSmartSize(size, SIZES, 'normal')
  const bgColorValue = useColor(bgColor, 'transparent')
  const disabledBgColorValue = useColor(disabled ? 'light2' : undefined)
  const borderStyle = useBorderStyle({ radius: 0.3, borderColor: 'light5', ...props })
  const paddingStyle = usePaddingStyle({
    paddingV: sizeValue.paddingV || 0.6,
    paddingH: sizeValue.paddingH || 0.9,
    ...props
  })

  return React.useMemo(() => {
    return `
			flex: 0;
			margin: 0;
      height: 100%;
      width: 100%;
      background: transparent;
			${borderStyle}
			${paddingStyle}
      ${applyStyle('min-heigth', sizeValue.height)}
      ${applyStyle('opacity', disabled, 0.5)}
			${applyStyle('background-color', bgColorValue)}
      ${applyStyle('background-color', disabled, disabledBgColorValue)}
      ${applyStyle('text-align', align || 'left')}
    `
  }, [align, bgColorValue, sizeValue, borderStyle, paddingStyle, disabled, disabledBgColorValue])
}
